import { Button } from "antd";
import { useEffect, useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import Lottie from "lottie-react";
import loader from "./images/loader.json";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import Work from "./pages/Work";
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  });

  return (
    <BrowserRouter>
      <div className="App">
        {loading ? (
          <div className="h-screen flex justify-center items-center">
            <Lottie className="max-w-md" animationData={loader} />
          </div>
        ) : (
          <Routes>
              <Route exact path='/' element={<Home />} />
              <Route exact path='/about' element={<About />} />
              <Route exact path='/work' element={<Work />} />
              <Route exact path='/admin' element={<Admin />} />
              <Route exact path='/admin/login' element={<AdminLogin />} />
          </Routes>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
